const productDataObject = {
  'shippingTotal': 45,
  'psv': 304.35,
  'tax': 29.73,
  'grandTotal': 234.23,
  'itemSubTotal': 200.32,
  'lineItemDetails': [ {
    ContractLength: 0,
    CreateDate: 1527746400000,
    Custom: null,
    Editable: true,
    EndDate: null,
    Held: false,
    LastOrderStatus: '',
    LastPlacedDate: null,
    MonthCount: 0,
    NextDeliveryDate: 1529647200000,
    OrderFrequency: 1,
    Overridden: false,
    SalesOrderDetail: [ {
      DROverrideNumber: '',
      Category: null,
      Channel: null,
      CommissionableInPriorMonth: false,
      CommissionedInPriorMonth: false,
      CountryCode: 'US',
      Currency: 'USD',
      Custom: [
        {Key: 'ZZPRICED_PACK_SL', Value: '', Type: ''},
        {Key: 'SENDER', Value: 'Dist Man', Type: 'SHIP'}
      ],
      Date: 1527746400000,
      DateCancelled: null,
      DateReturned: null,
      ExternalID: null,
      GiftReciept: null}

    ]}
  ],
  'pointsBalance': 3423.00,
  'updateType': 'none',
  'products': [
    {
      grandFatheredPricing: false,
      name: 'Bone Formula',
      oneTime: false,
      requestedQuantity: 7,
      sku: '01003331'
    },
    {
      grandFatheredPricing: false,
      name: 'LifePak® Anti-Aging Formula',
      oneTime: false,
      requestedQuantity: 3,
      sku: '01003680'

    }
  ],
  'oneTimeProducts': [
    {
      grandFatheredPricing: false,
      name: 'LifePak® Anti-Aging Formula',
      oneTime: true,
      requestedQuantity: 1,
      sku: '01003682'
    }
  ]
};

module.exports.productDataObject = productDataObject;
